import { render, staticRenderFns } from "./TenantEditLocks.vue?vue&type=template&id=414b3f4d&scoped=true&"
import script from "./TenantEditLocks.vue?vue&type=script&lang=js&"
export * from "./TenantEditLocks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "414b3f4d",
  null
  
)

export default component.exports